import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29dabfe2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=29dabfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dabfe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29dabfe2')) {
      api.createRecord('29dabfe2', component.options)
    } else {
      api.reload('29dabfe2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29dabfe2&scoped=true&", function () {
      api.rerender('29dabfe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Profile/index.vue"
export default component.exports